import { useNavigate } from "react-router-dom";
import { Instagram, Mail, MapPin, MessageCircle } from "lucide-react";
import Logo from "@/components/Logo";

export const Footer = ({ footerText, contactLabel, onConsult, distLabel }) => {
  const navigate = useNavigate();
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="footer-brand"><Logo variant="light" /></div>
      <p>{footerText}</p>
      <div className="footer-contact" data-testid="footer-contact">
        <a href="mailto:hello@edenhospitalitybali.com" data-testid="footer-email-link"><Mail size={14} /> hello@edenhospitalitybali.com</a>
        <a href="https://wa.me/6285190679319" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link"><MessageCircle size={14} /> +62 851-9067-9319</a>
        <a href="https://instagram.com/edenhospitality" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link"><Instagram size={14} /> @edenhospitality</a>
        <span className="footer-area" data-testid="footer-area"><MapPin size={14} /> Bali, Indonesia</span>
      </div>
      <div className="footer-links">
        {distLabel && <button onClick={() => navigate("/distribution")} data-testid="footer-distribution-link">{distLabel}</button>}
        <button onClick={() => navigate("/concierge")} data-testid="footer-concierge-link">Concierge</button>
        <button onClick={() => navigate("/housekeeping-maintenance")} data-testid="footer-housekeeping-link">Housekeeping & Maintenance</button>
        <button onClick={() => navigate("/marketing")} data-testid="footer-marketing-link">Brand & Marketing</button>
        <button onClick={onConsult} data-testid="footer-contact-button">{contactLabel}</button>
      </div>
      <span className="copyright">© 2026 Eden Hospitality</span>
    </footer>
  );
};
